<template>
  <div :class="containerClass">
    <!-- {{ images }} -->
    <!-- {{ imagesByIndex }} -->

    <div
      class="d-flex flex-column justify-space-between align-start pointer text-center d-print-none"
      v-for="(obj, i) in imagesByIndex"
      :key="i"
      @click="toggleDialog(i)"
    >
      <!-- {{ path + obj.src }} -->
      <div v-if="obj.slug" :id="obj.slug"></div>
      <v-img
        :src="path + obj[imageKey]"
        :max-height="iconHeight"
        :max-width="maxWidth ? maxWidth : iconWidth"
        :class="iconClass"
        :lazy-src="placeholder"
        :altText="obj.label"
        contain
        :style="iconStyle"
        :position="position"
      />
      <div v-if="obj[captionKey]" class="caption text-center width100p">
        {{ obj[captionKey] }}
      </div>
    </div>

    <v-dialog
      v-model="imageDialog"
      :fullscreen="fullscreen"
      :max-width="fullscreen ? '100%' : maxDialogWidth"
      :hide-overlay="fullscreen"
      class="relativeClass"
    >
      <v-card class="d-print-none">
        <v-toolbar dense rounded>
          <v-spacer></v-spacer>
          <v-btn
            style=""
            icon
            v-if="showNavigation"
            class="ma-2"
            @click.stop="doNavigate(-1)"
            ><v-icon color="primary" large>mdi-chevron-left</v-icon></v-btn
          >
          <v-btn
            style=""
            icon
            v-if="showNavigation"
            class="ma-2"
            @click.stop="doNavigate(1)"
            ><v-icon color="primary" large>mdi-chevron-right</v-icon></v-btn
          >

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="openInNew()"
                class="ma-2"
                v-on="on"
                v-bind="attrs"
                ><v-icon color="primary">mdi-open-in-new</v-icon></v-btn
              >
            </template>
            <span>Open in a new tab</span>
          </v-tooltip>

          <v-btn text color="primary" @click="toggleDialog(null)" class="mx-3">
            <v-icon color="primary" class="ma-2">mdi-close</v-icon>
            Close</v-btn
          >
        </v-toolbar>

        <v-container class="d-print-none">
          <v-row>
            <v-col
              cols="12"
              lg="3"
              v-show="canShowQuickCalcs && localShowCalcs"
            >
              <div style="height: 2.5em">
                <v-btn
                  text
                  color="primary"
                  small
                  @click="localShowCalcs = false"
                  v-if="localShowCalcs"
                >
                  <v-icon small color="primary" class="mr-2"
                    >mdi-lightning-bolt</v-icon
                  >
                  Hide Quick Calcs</v-btn
                >
              </div>
              <quick-calcs :hideCloseButton="true"></quick-calcs>
              <v-textarea
                placeholder="scratch pad"
                background-color="yellow lighten-4"
                class="my-2"
                solo
              ></v-textarea>
            </v-col>
            <v-col cols="12" :lg="localShowCalcs ? 9 : 12">
              <div style="height: 2.5em" v-if="canShowQuickCalcs">
                <v-btn
                  text
                  color="primary"
                  small
                  @click="localShowCalcs = true"
                  v-if="!localShowCalcs"
                >
                  <v-icon small color="primary" class="mr-2"
                    >mdi-lightning-bolt</v-icon
                  >
                  Show Quick Calcs
                </v-btn>
              </div>
              <v-img
                class="ml-0 ml-sm-4"
                :src="selectedImage"
                alt=""
                dark
                max-height="90vh"
                max-width="90vw"
                contain
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "DialogLightbox",
  components: {
    QuickCalcs: () => import("@/components/calcsStuff/QuickCalcs.vue"),
  },
  props: {
    images: null, // can be a sting, an array of paths [path1, path2], or an array of objects [{src:xxx, label:xxx},{. . .}]
    imagePath: null, // assume full path
    imageKey: { type: String, default: "src" }, // if images is an object, this is the file key
    iconClass: { type: String, default: "my-2 mr-2" },
    iconStyle: { type: String, default: null },
    iconHeight: { type: Number, default: 100 },
    iconWidth: { type: Number, default: 100 },
    maxWidth: null,
    placeholder: null,
    captionKey: { type: String, default: "label" },
    containerClass: {
      type: String,
      default: "d-flex flex-row flex-wrap justify-center justify-sm-start",
    },
    canNavigate: { type: Boolean, default: true },
    fullscreen: { type: Boolean, default: true },
    maxDialogWidth: { type: Number, default: 500 }, // if not fullscreen
    canShowQuickCalcs: null,
    canOpenInNew: { type: Boolean, default: true },
    openImage: { type: String, default: null }, // takes a slug
    position: { type: String, default: "center" },
  },
  data: function () {
    return {
      //  selectedImage: null,
      imageDialog: false,
      selectedIndex: null,
      localShowCalcs: false,
    };
  },
  methods: {
    toggleDialog(index) {
      this.imageDialog = !this.imageDialog;
      if (this.imageDialog) this.selectedIndex = index;
      // this.selectedImage = this.imageDialog ? path : null;
    },
    doNavigate(dir) {
      let temp = this.selectedIndex + dir;
      if (temp < 0) temp = this.imageCount - 1;
      if (temp == this.imageCount) temp = 0;
      this.selectedIndex = temp;
    },
    openInNew() {
      var URL = this.selectedImage;
      window.open(URL);
    },
    imageIndexForSlug(slug) {
      let rtn = null;
      this.imagesByIndex.forEach((obj, i) => {
        if (obj.slug == slug) rtn = i;
      });
      return rtn;
    },
  },
  computed: {
    path: function () {
      return this.imagePath ? this.imagePath : "";
    },
    selectedImage: function () {
      if (!this.imagesByIndex?.[this.selectedIndex]) return null;
      return this.path + this.imagesByIndex[this.selectedIndex][this.imageKey];
    },
    inputType: function () {
      return typeof this.images;
    },
    imagesByIndex: function () {
      let rtn = null;
      let type = this.inputType;
      if (type === "string") {
        rtn = [{ src: this.images, label: null }];
      } else if (type === "object" && this.images.src) {
        // it's an object
        rtn = [this.images];
      } else if (type === "object") {
        rtn = [];
        // an array of strings or array of objects
        this.images.forEach((row) => {
          if (typeof row === "string") {
            rtn.push({ src: row, label: null });
          } else {
            // assume  array item is an object
            rtn.push(row);
          }
        });
      }
      return rtn;
    },
    imageCount: function () {
      return this.imagesByIndex ? this.imagesByIndex?.length : 0;
    },
    // -1 is don't show nav, 0 is disable nav, 1 is show/enable nav
    showNavigation: function () {
      return this.canNavigate && this.imageCount > 1;
    },
  },
  watch: {
    // takes a slug (usually passed in via the route hash / filter)
    // if the slug is present, open the dialog and set the selected index
    openImage: function (val) {
      // console.log("scrollTo", val);
      let index = this.imageIndexForSlug(val);
      if (index) this.toggleDialog(index);
    },
  },
};
</script>

<style scoped>
.relativeClass {
  position: relative;
}
.navClass {
  position: absolute;
  width: 95%;
  top: 50%;
}
.closeBtnClass {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
